import { useState } from "react";
import DatetimePicker from "components/elements/dateTimePicker";
import { connect } from "react-redux";
import useCallApiUrl from "hook/useCallApiUrl";
import Loading from "components/Loading";
import AdminFulfill from "./fulfill";
import TableUserFulfill from "./tableUserFulfill";

const ProductAnalytic = () => {
    const [filter, setFilter] = useState({});
    const { data, loading } = useCallApiUrl(
        "/api/analytic/admin/fulfill",
        filter,
        Object.keys(filter).length > 0
    );
    const { data: userFulfill, loading: loadingUserFulfill } = useCallApiUrl(
        "/api/analytic/admin/user-fulfill",
        filter,
        Object.keys(filter).length > 0
    );

    return (
        <div className="d-flex flex-column gap-6" style={{ maxWidth: "1780px", margin: "auto" }}>
            <Loading isLoading={loading || loadingUserFulfill} />
            <div className="d-flex gap-2 mb-4">
                <DatetimePicker
                    onChange={(data) => setFilter((prev) => ({ ...prev, ...data }))}
                    typeDefault="last_week"
                />
            </div>

            <div className="card card-body">
                <AdminFulfill data={data || {}} />
            </div>
            <div className="card card-body">
                <TableUserFulfill data={userFulfill || []} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAnalytic);
